export default [
  'Médico',
  'Nutricionista',
  'Dentista',
  'Psicólogo',
  'Enfermeiro',
  'Fonoaudiólogo',
  'Fisioterapeuta',
  'Biomédico',
  'Farmacêutico',
  'Educador Físico',
  'Terapeuta'
].sort()
